import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Upload de imagem servido pelo quarkus.
export function useUploadImage() {
  const [isUploading, setUploading] = useState(false);

  const upload = useCallback((formData) => {
    setUploading(true);
    return quarkusApi
      .post('/images', formData, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setUploading(false));
  }, []);

  return { upload, isUploading };
}
